import { styled } from '../../../core/theme/styled';
import { Caption, Text } from '../../atoms/Text/Text';

export const Divider = styled.div`
  margin: ${(props) => props.theme.sizes.xsmall} 0;
  border-top: 1px solid ${(props) => props.theme.configuration.strokeColor};
`;

export const SplitItems = styled.div`
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  margin-bottom: ${(props) => props.theme.sizes.xxxsmall};
`;

export const Label = styled(Caption)`
  color: inherit;
`;

export const Value = styled(Text)`
  color: inherit;
`;
